import { render, staticRenderFns } from "./OrderProductsReturn.vue?vue&type=template&id=4c05b230"
import script from "./OrderProductsReturn.vue?vue&type=script&lang=js"
export * from "./OrderProductsReturn.vue?vue&type=script&lang=js"
import style0 from "./OrderProductsReturn.vue?vue&type=style&index=0&id=4c05b230&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports